module.exports = __webpack_public_path__ + "assets/images/img/photo.63a31f24ff5efa83b091e0d108c9ef94.jpg";